import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { getCountdownValues } from '@src/utils/time.utils';
export const useCountdown = targetDate => {
  const $ = _c(8);
  let t0;
  if ($[0] !== targetDate) {
    t0 = new Date(targetDate).getTime();
    $[0] = targetDate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const countDownDate = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Date().getTime();
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [countDown, setCountDown] = useState(countDownDate - t1);
  let t2;
  let t3;
  if ($[3] !== countDownDate) {
    t2 = () => {
      const interval = setInterval(() => {
        setCountDown(countDownDate - new Date().getTime());
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    };
    t3 = [countDownDate];
    $[3] = countDownDate;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== countDown) {
    t4 = getCountdownValues(countDown);
    $[6] = countDown;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};